// en, de, fr, pt
export default {
  en: {
    profile: {
      Title: 'Profile',
      PasswordUpdated: 'Password Updated. Please login with your new password.',
      Info: 'Personal Informations',
      Admin: 'Admin Panel',
      Settings: 'Account Settings',
      ChangePassword: 'Change Password',
      MyDeviceRentals: 'My Device Rentals',
      Logout: 'Logout',
      Accept: 'Save',
      Close: 'Close',
      Name: 'Name{scolon}',
      Username: 'Username{scolon}',
      Timezone: 'Timezone{scolon}',
      language: {
        Title: 'Language{scolon}',
        Tr: 'Turkish',
        En: 'English'
      },
      SelectLanguage: 'Language Selection',
      OldPassword: 'Old Password{scolon}',
      OldPasswordError: 'Old password can not be empty.',
      NewPassword: 'New Password{scolon}',
      NewPasswordSec: 'New Password Again{scolon}',
      NewPasswordError: 'New password can not be empty.',
      NewPasswordNoMatch: 'Password confirmation does not match.',
      NewPasswordSecError: 'Password confirmation cannot be blank.',
      Accountsettings: {
        Tab1Title: 'User Settings',
        Tab2Title: 'SMS Settings',
        Tab3Title: 'Language Settings',
        PhoneWarningMessage: 'Please verify your phone number to activate SMS notifications.',
        ConfirmationCode: 'Confirmation Code',
        ConfirmationCodeMessage: 'Please enter the 6-digit security code sent to your phone.',
        ConfirmationCode404Message: 'You entered the wrong code.',
        ConfirmationCode400Message: 'The last sms request has not expired. You cannot request new sms right now.',
        SuccessMessage: 'Your account information has been updated.',
        ValidateCodeSuccessMessage: 'Your phone number has been verified.',
        MissingCodeError: 'You entered the missing code.'
      }
    },
    notifications: {
      Title: 'Notifications',
      NoMessages: 'No messages.',
      NotificationType: {
        Alarm:'Alarm Notification'
      }
    },
    maintenance:{
      Title:'Under Maintenance 🛠',
      Text:'Sorry for the inconvenience but we\'re performing some maintenance at the moment.'
    },
    authFooter: {
      UserAgreement: 'User Agreement',
      CookiePolicy: 'Cookie Policy',
      PrivacyPolicy: 'Privacy Policy',
      RentalAgreement: 'Rental Agreement',
      updateText: 'Last Updated:'
    },
    login: {
      Title: 'Login',
      MessageTitle: 'Welcome back to Hexasense! 👋',
      Message: 'Please login with your account.',
      FormMail: 'Email',
      FormMailEmpty: 'Email can not be empty.',
      FormMailValid: 'Enter a valid email',
      FormPassword: 'Password',
      FormPasswordEmpty: 'Password can not be empty.',
      FormPhone: 'Phone Number',
      FormPhoneEmpty: 'Phone Number can not be empty.',
      FormRemember: 'Remember Me',
      ForgotPassword: 'Forgot your password?',
      ForgotPasswordMessage:
        'Please enter your email address and we will send you instructions on how to reset your password.',
      CreateAnAccount:{
        text:'New on our platform?',
        button:'Sign Up'
      },
      AlreadyHaveAnAccount:{
        text:'Already have an account.',
        button:'Login'
      },
      BackToLogin:'Back to login',
      SignUp: 'Sign Up',
      Login: 'Login',
      SavePassword: 'Recover Password',
      LoggedIn: 'Welcome!',
      reset: {
        Title: 'Reset Password',
        NewPassword: 'Please enter new password.',
        ResetPassword: 'Reset Password'
      },
      ConfirmPhoneNumberText: 'In order to receive SMS Notifications, you must register your phone number in the system.'
    },
    register: {
      Title: 'Create Account',
      Message: 'Please fill this form to create a new account.',
      FormPasswordLength: 'Password length must be at least {length} characters.',
      FirstName: 'First Name',
      FormFirstNameEmpty: 'First Name can not be empty.',
      LastName: 'Last Name',
      FormLastNameEmpty: 'Last Name can not be empty.',
      ConfirmPassword: 'Confirm Password',
      FormPConfirmPasswordEmpty: 'Confirm Password can not be empty.',
      PasswordNoMatch: 'Passwords does not match',
      TermsAndCondsOk: {
        text: 'By registering you confirm that you have read and accepted {policyButton1}. Please review the {policyButton2} and {policyButton3} Policy regarding the processing of your personal data.',
        policyButton1: 'User Agreement',
        policyButton2: 'Privacy',
        policyButton3: 'Cookie',
        acceptText:'I have read the Clarification text on the User Agreement above, I have learned how the User Agreement will be processed.'
      },
      TermsAndCondsOkBtn: 'Accept',
      FormTermsConditionAccepted: 'Please confirm the User Agreement.',
      ModalSuccess: {
        Title: 'Success!',
        Text:
          'User has been saved. Please check your email to validate your account.'
      },
      ModalFail: {
        Title: 'Error!'
      },
      activated: {
        Welcome: 'Welcome',
        RedirectRegister: {
          text: 'Please click {button} to redirect to register page.',
          button: 'here'
        },
        RedirectLogin: {
          text: 'Please click {button} to login to platform.',
          button: 'here'
        },
        success: {
          title: 'Your account has been activated.',
          text: 'You are being redirected to the login page, please wait.'
        }
      }
    },
    messagebox: {
      ErrorMsg: 'There was an error. Please try again.',
      NotAllowedError:
        'Hey! I need access to your camera, please let it continue.',
      NotFoundError: 'Does your device have a camera?',
      NotSupportedError: 'This page seems unsafe',
      InsecureContextError:
        'Camera access is only allowed in the secure context. Use HTTPS or localhost instead of HTTP.',
      NotReadableError:
        'Your camera could not be accessed. Is it already used?',
      OverconstrainedError:
        'Constraints don\'t match any installed camera. Did you asked for the front camera although there is none?',
      ECONNABORTED: 'Api request timed out. Please try again later.',
      RegisterError: 'There is already a user registered with this email address.',
      AlreadyApiary: 'Apiary with this name already exists.',
      WrongActivationCode: 'Your activation code is wrong. Please check the activation email we have sent to you.',
      88: 'Qr code cannot be empty',
      89: 'This phone does not support geolocation.',
      90: 'The QR code you read is not a HexaSense device.',
      98: 'The session has expired. Please login.',
      99: 'You do not have permission to access the platform. Please login.',
      100: 'Server Error',
      101: 'Please fill the form.',
      102: 'Passwords do not match.',
      105: 'Please accept the Hexasense terms and conditions.',
      400: 'Select a valid choice. That choice is not one of the available choices.',
      500: 'Internal Server Error',
      404: 'Requested resource not exists',
      409: 'Requested resource exists',
      401: 'Token is invalid or expired',
      1000: 'This device is already registered',
      1002: 'This device is already assigned to the user',
      1003: 'Device token does not match',
      1004: 'Device not found',
      1005: 'This device is already active',
      1006: 'Device activation not allowed',
      1007: 'The device is not active.',
      4000: 'Parameters are required',
      4001: 'Your old password is wrong. Please check your old password.',
      4002: 'There is no user registered with this email address.',
      4003: 'There is already a user registered with this email address.',
      4004: 'This user is already active.',
      4005: 'Your activation period has expired. Please request a new activation email.',
      4030: 'The time we gave you to reset the password has expired. Please make a new request. ',
      4031: 'Invalid password renewal request. Please request a new link. ',
      4080: 'An account with the given credentials was not found.',
      4081: 'You need to activate your account.',
      4082: 'Please check the accuracy of your login information.',
      2001: 'A mail has been sent to your email address to reset the password. Please check your email address.',
      2002: 'Your password has been successfully updated. Please login with your new password..',
      2003: 'Your account has been activated.',
      6001:'The location information of your hive could not be reached.'
    },
    sidebar: {
      Homepage: 'Home',
      Apiaries: 'Apiaries',
      Hives: 'Hives',
      Warnings: 'Alarms',
      Rules: 'Rules'
    },
    breadcrumbs: {
      HiveFromQr: 'Add New Hive / QR Code',
      HiveWithId: 'Hives / Hive {n}',
      EditRule: 'Edit Rule',
      ShowRule: 'Show Rule'
    },
    homepage: {
      cards: {
        DeviceInfoName: 'Device Information',
        RentalInfoName: 'Rental Information',
        Apiary: 'Total Apiaries',
        Hives: 'Hives',
        TotalHives: 'Total Hive',
        HealthyHivesCount: 'Healthy Hive',
        MotionDetection: 'Motion Detection',
        Alarms: 'Alarms',
        InactiveRents: 'Expired',
        UpcomingRentals: 'Will Expire'
      },
      weather: {
        Title: 'Weather Forecast',
        TakingWeatherForecast: 'Retrieving weather forecast...',
        ApiaryNotFound: 'There is no "Apiary" to show weather forecast.',
        Modal: {
          GetFail: 'Error! Weather forecast can not be retrieved.'
        }
      },
      map: {
        noData: 'There is no user\'s apiary.'
      },
      NotHiveWarningMessage: 'It looks like you don\'t have a hive yet. Add a new hive if you have the Product Key.',
      NotApiaryWarningMessage: 'It looks like you don\'t have apiaries yet. Add apiaries on the Apiaries page.'
    },
    apiaries: {
      AddNewApiary: 'Add New Apiary',
      AddApiary: 'Add Apiary',
      LastUpdate: 'Last Update',
      SelectApiary: 'Select a Apiary',
      filters: {
        UserOrCompany: 'Beekeeper or Company',
        UserPlaceholder: 'Select a Beekeeper or Company',
        NoResult: 'No matching item found',
        Empty: 'Empty List',
        Company: 'Company',
        CompanyPlaceholder: 'Select a Company'
      },
      FiltersMsg: 'There is no apiary for this user.',
      UserNotApiaryMessage:'You have no apiary. Currently, you\'re listing other account\'s apiaries',
      Latitude:'Latitude',
      Longitude:'Longitude',
      new: {
        ApiaryName: 'Apiary Name',
        Required: 'This field can not be empty.',
        Date: 'Date',
        SearchLocation: 'Search Location',
        Country: 'Country',
        City: 'City',
        District: 'District',
        Save: 'Save',
        Humidity: 'Humidity',
        Temperature: 'Temperature',
        SuccessAddMessage: 'New apiary succesfully added.'
      },
      ApiaryDetail: 'Apiary Detail',
      DeleteApiary: 'Delete Apiary',
      EditApiary: 'Edit Apiary',
      detail: {
        Hive:'Hive',
        Alarms:'Alarms',
        InternalTemperature: 'Internal Temperature',
        Average:'Average',
        TheHottest:'The Hottest',
        TheColdest: 'The Coldest',
        MostHumid:'Most Humid',
        TheHeaviest: 'The Heaviest',
        Weight:'Weight',
        Last15Days:'Last 15 Days',
        StatisticsCardInfo:'According to the data from the hives.'
      },
      edit: {
        EditApiaries: 'Edit Apiary',
        ApiaryEdited: 'Apiary successfully edited.'
      },
      delete: {
        DeleteMessage:
          'You are doing the deletion for <strong>{name}</strong> apiary. After confirming the deletion, all information regarding the <strong>{name}</strong> apiary will be deleted. ',
        Proceed:
          'If you want to continue, <strong>"Continue Processing"</strong> click to the button.',
        ProceedButton: 'Continue',
        DeleteApiary: 'Delete Apiary',
        ConfirmDelete: 'Do you want to delete this apiary?',
        CancelButton: 'Cancel',
        ApiaryDeleted: 'Apiary has been deleted.'
      },
      allApiaries: 'All Apiaries',
      myApiaries: 'My Apiaries',
      selectedApiary: 'Selected Apiaries'
    },
    hives: {
      NoApiary:
        'You must have at least one bee hive before you can add a new hive.',
      AddApiaryMessage: 'Please add apiary first.',
      CreateNewHive: 'Create New Hive',
      CreateHive: 'Create Hive',
      AddDevice: 'Add New Device',
      HiveDetail: 'Hive Detail',
      HiveOnline: 'Online',
      HiveOffline: 'Offline',
      Bee:'Bee',
      BeeAge:'{age} month old | {age} months old',
      UserNotApiaryMessage:'You have no hive. Currently, you\'re listing other account\'s hives. To create a hive, you need to create apiary first',
      UserNotHiveMessage:'You have no hive. Currently, you\'re listing other account\'s hives.',
      delete: {
        Title: 'Delete Hive',
        DeleteMessage:
          'You are deleting the <strong>{name}</strong> hive. After confirming the deletion all information about the <strong>{name}</strong> hive will be deleted. ',
        ConfirmDelete: 'Do you want to delete this hive?',
        Delete: 'Delete',
        SuccessMessage: 'Hive has been deleted.'
      },
      ClearBtn: 'Clear',
      FiltersMsg: 'There is no hive for this user.',
      ApiaryFiltersMsg: 'There is no hive for this apiary.',
      Myhive: 'My Hives',
      Imei: {
        CopySuccessMessage: 'Imei copied successfully.',
        CopySErrorMessage: 'There was an error copying the Imei.'
      },
      detail:{
        EditHive: 'Edit Hive',
        DeleteHive: 'Delete Hive',
        ViewCharts:'View Charts',
        HiveType: 'Hive Type',
        QueenBee: 'Queen Bee',
        Alarm: 'Alarm',
        InstallationDate: 'Installation Date',
        Apiary:'Apiary',
        Temperature: 'Temperature',
        Humidity: 'Humidity',
        Weight:'Weight',
        Today:'Today',
        InTheLastData:'In The Last Data',
        AverageOver24Hours: 'Average Over 24 Hours',
        BatteryStatus: 'Battery Status',
        SignalPower: 'Signal Power',
        DeviceSerial: 'Device Serial Number',
        Sickness:'Sickness',
        NoteMessage:'According to the notes you have added to the hive',
        LastFeed: 'Last Feed',
        LastDisinfection: 'Last Disinfection',
        WeatherForecast: 'Weather Forecast',
        AddDevice: 'Add Device',
        NoDeviceMessage: 'There is no device connected to the hive.',
        NoAlarm: 'There is no alarm.',
        NotAvailable: 'Not Available',
        NoDisease: 'No Disease',
        charts:{
          Humidity: 'Humidity',
          Temperature: 'Temperature',
          Weight:'Weight',
          NoChartDataMessage:{
            Humidity: 'There is no humidity information for the hive between these two dates.',
            Temperature: 'There is no temperature information for the hive between these two dates.',
            Weight: 'There is no weight information for the hive between these two dates.'
          },
          BroodZone:'Brood Zone',
          titles: {
            Humidity: 'Humidity {p}',
            InternalHumidity: 'Internal Humidity {p}',
            ExternalHumidity: 'External Humidity {p}',
            Temperature: 'Temperature {p}',
            InternalTemperature: 'Internal Temperature {p}',
            ExternalTemperature: 'External Temperature {p}',
            Weight:'Weight {p}'
          }
        }
      },
      Device: {
        Title: 'Device',
        SelectDevice: 'Select Device',
        NoDevice: 'No device connected',
        EmptyWarningMessage: 'There is no device for this user.',
        new: {
          Welcome: 'Welcome,',
          WelcomeMessage:
            'After you have create your device rental, you can add your device with the <b>"Product Key"</b> we have sent to you by e-mail.',
          ProductKey: 'Product Key',
          ProductKeyLengthError: 'You have entered the product key incomplete.',
          Start: 'Start',
          TCIdentityNumber: 'TC Identity Number',
          FormTCIdentityNumberError: 'Please enter a valid TR Identity Number.',
          Address: 'Residence Address',
          CheckCheckboxText: 'I confirm the accuracy of the information I have entered.',
          CheckCheckboxError: 'Please confirm your information.',
          RentalConfirmWarningMessage: 'To add a device, you must accept the Rental Agreement.',
          SuccessMessage: 'Device has been saved successfully.'
        }
      },
      new: {
        User: 'User',
        Code: 'Product Code',
        Serial: 'Serial Number',
        Apiary: 'Apiary',
        SelectApiary: 'Select Apiary',
        NoResult: 'No matching item found',
        Empty: 'Empty',
        Required: 'Please select an apiary',
        RequiredUser: 'Please select an user',
        Name: 'Hive Name',
        QueenBeeDateOfBirth: 'Queen Bee Date of Birth',
        BeeType: 'Bee Type',
        SelectBeeType: 'Select Bee Type',
        HiveType: 'Hive Type',
        SelectHiveType: 'Select Hive Type',
        CancelButton: 'Cancel',
        Save: 'Save',
        SuccessMessage: 'Hive has been saved successfully.',
        ScanQrCode: 'Scan QR Code',
        AddWithProductCode: 'Add With Product Code and Serial Number',
        AddWithProductCodeForm:
          'Please fill in the form given below completely.',
        CameraMessage:
          'Before adding a new device you need to give <b>\'Camera\'</b> permission.',
        QrStepOne:
          'After giving the necessary permissions, the camera will turn on. Then read the  <b>\'QR Code\'</b> section on the device to the camera.',
        QrStepTwo:
          'If scanned QR code belongs to a <b>\'HexaSense\'</b> device, you will be directed to device adding page'
      },
      edit: {
        EditHives: 'Edit Hive',
        WarningMessage: 'Please update the hive information to see the hive details.',
        SuccessMessage: 'Hive has been edited successfully.',
        UserNoApiary: 'Please ask your user to add apiary.',
        NoApiary: {
          text: 'Click {button} to add apiaries.',
          button: 'here'
        }
      },
      signal: {
        Weak: 'Weak',
        Middle: 'Middle',
        Strong: 'Strong'
      },
      battery: {
        Low: 'Weak',
        Normal: 'Normal'
      },
      allHives: 'All Hives'
    },
    hivenote: {
      Title: 'Hive Notes',
      AddNote: 'Add Note',
      AddNewNote: 'Add New Note',
      PageButton: 'My Notes',
      table: {
        Device: 'RELATED HIVE',
        Date: 'NOTE DATE',
        Type: 'NOTE TYPE',
        Action: 'ACTION'
      },
      new: {
        Title: 'Add Note For Hive',
        form: {
          device: 'Hive',
          actionDate: 'Action Date',
          actions: 'Action',
          actionNote: 'Action Note',
          note: 'Note',
          frameCount:'Frame Count'
        },
        FrameCountErrorMessage:'This field can only contain numeric characters. Please enter a value between 0 and 48.',
        SelectActionDate: 'Select Action Date',
        SelectAction: 'Select Action',
        SelectDevice: 'Select Hive',
        SuccessMessage: 'Note created for the hive.',
        SwitchLeft:'To The Hives',
        SwitchRight:'To The Apiaries'
      },
      edit: {
        Title: 'Edit Note',
        SuccessMessage: 'Note Updated.'
      },
      delete: {
        Title: 'Delete Note',
        WarningMessage: 'Do you want to delete the note?',
        SuccessMessage: 'Note Deleted.'
      },
      show: {
        Title: 'Show Note'
      }
    },
    rules: {
      main: {
        AddRule: 'Add New Rule',
        thead: {
          Name: 'RULE NAME',
          Rules: 'BINDING RULES',
          ApiaryCount: 'APIARY COUNT',
          NotificationType: 'NOTIFICATION OPTIONS',
          Actions: 'ACTIONS'
        },
        NoRules: 'No registered rules.',
        NotificationSettingsTooltips: {
          Sms: 'SMS Notification is On',
          Email: 'Email Notifications On',
          Platform: 'Platform Notifications On'
        }
      },
      new: {
        Name: 'Rule Name',
        AllApiaries: 'All Apiaries',
        ApiariesPlaceholder: 'Select Apiary',
        RequiredApiaries: 'Please select at least one Apiary.',
        RequiredRules: 'Please select at least one Rule.',
        RequiredNotificationType: 'Please select at least one Notification Type.',
        NotificationSettingsTitle: 'Notification Settings',
        AlarmSettingsTitle: 'Alarm Settings',
        ApiarySettingsTitle: 'Apiary Settings',
        ApplyNewApiariesCheckbox: 'Apply this rule for newly created apiaries.',
        RequiredApiary: 'Before you can add a new rule, you must have at least one apiary.',
        AllSelectedApiaryMessage:'There is a defined rule for all your apiaries. Please add apiary to add a new rule.', 
        AddApiary: 'Please add a new apiary first.',
        NoSelectApiaryTootltip: 'This apiary has been associated with another rule.',
        DataTypeOptions: {
          Temperature: 'Temperature',
          Humidity: 'Humidity',
          Vibration: 'Vibration'
        },
        DataTypeRule: {
          Temperature: {
            text: 'Receive alarm if the temperature value is less than {min}°C and/or greater than {max}°C.',
            min: '',
            max: ''
          },
          Humidity: {
            text: 'Receive alarm if the humidity is less than {min}% and/or greater than {max}%.',
            min: '',
            max: ''
          },
          Vibration: 'Receive alarm when vibration occurs.'
        },
        DataNotificationsOptions: {
          Web: 'I want to via Platform',
          Mail: 'I want to receive via Email',
          Sms:'I want to receive via SMS'
        },
        SelectAllApiaryBtn: 'Select All Apiaries',
        ClearBtn: 'Clear',
        SuccessAddMessage: 'New rule has been added successfully.'
      },
      edit: {
        SelectApiary: 'Apiary',
        SuccessMessage: 'Rule has been edited successfully.'
      },
      delete: {
        Title: 'Delete Rule',
        DeleteMessage:
          'You are deleting for <strong>{name}</strong> rule. After confirming the deletion. All information about the <strong>{name}</strong> will be deleted. ',
        Proceed:
          'If you want to continue <strong>"Continue Processing"</strong> click to button.',
        ProceedButton: 'Continue',
        DeleteQuestion: 'Do you want to delete this rule?',
        Deleted: 'Rule deleted.'
      },
      formErrors: {
        MaxMin: 'The second value is not less than the first value.',
        MaxMinEmpty: 'You must specify at least one of the Maximum value or Minimum value.',
        MaxMinMatch: 'The two values cannot be the same.'
      }
    },
    alarms: {
      thead: {
        RelatedHive: 'RELATED HIVE',
        RelatedApiary: 'RELATED APIARY',
        DataType: 'DATA TYPE',
        MeasuredValue: 'MEASURED VALUE',
        CreatedAt: 'CREATED AT',
        Actions: 'ACTIONS'
      },
      DeleteModalTitle: 'Delete Alarm',
      DeclaredRules: 'Defined Rules',
      DeleteAlarmQuestion: 'Do you want to delete the alarm?',
      ButtonClose: 'Close',
      ButtonDelete: 'Delete',
      NoAlarm: 'There are no recorded alarms.',
      Loading: 'Loading...',
      NoDataError: 'There is a problem',
      DeleteSuccess: 'Alarm deleted.',
      NoMatchingData: 'No data Available.',
      allAlarms: 'All Alarms'
    },
    admin: {
      Title: 'Admin Panel',
      AddUser: 'Add New User',
      tab: {
        user: 'User Management',
        device: 'Device Management'
      },
      thead: {
        User: 'USER',
        Role: 'ROLE',
        Actions: 'ACTIONS'
      },
      NoMatchingData: 'No data Available.',
      NoDataError: 'There is a problem',
      NoUser: 'There are no recorded users.',
      Loading: 'Loading...',
      newUserModal: {
        Title: 'New User',
        form: {
          Email: 'Email',
          FormMailEmpty: 'Email can not be empty.',
          FormNameEmpty: 'Name can not be empty.',
          FormSurnameEmpty: 'Surname can not be empty.',
          FormCompanyEmpty: 'Company can not be empty.',
          FormTelephoneEmpty: 'Phone Number can not be empty.',
          FormTelephoneErr: 'Wrong Phone Number.',
          Password: 'Password',
          Company: 'Company',
          Name: 'Name',
          Surname: 'Surname',
          Telephone: 'Phone Number',
          TelephoneCountryCode: 'Country Code',
          TelephoneCountryCodeError: 'Select a Country',
          TelephoneExample: 'Example :'
        },
        SuccessMessage: 'User created!',
        SuccessMessageText: 'User information passed to the user.'
      },
      deleteUserModal: {
        Title: 'Deleting a User',
        WarningMessage: 'All information belonging to this user will be deleted. Do you want to delete the user?',
        SuccessMessage: 'User deleted.',
        NoDataError: 'There is a problem.'
      },
      copyPassword: {
        Success: 'Password copied successfully',
        Error: 'Could not copy password'
      },
      roles: {
        Manager: 'Manager',
        User: 'User'
      },
      panelErrorMess: 'You are not authorized to login to the Admin Panel.',
      errorCode: {
        400: 'User with this email already exists.',
        500: 'Internal Server Error.(500)'
      },
      allUsers: 'All Users',
      devices: {
        NoDevice: 'There are no recorded devices.',
        table: {
          deviceSerial: 'Device Serial',
          productCode: 'Product Code',
          simNumber: 'Sim Number',
          simProvider: 'Sim Operator',
          rentalStatus: 'Rental Status',
          rentDate: 'Rent Start',
          rentPeriod: 'Rent Period (Year)',
          rentFinishDate: 'Rent Finish',
          actions: 'Actions'
        },
        CreateRentalBtn: 'Create Rental',
        chip: {
          passive: 'Passive',
          active: 'Active'
        },
        actionEditButton: 'Edit',
        filters: {
          rented: {
            all: 'All',
            rented: 'Rented',
            notRented: 'Not Rented'
          }
        },
        edit: {
          Title: 'Device Edit',
          cardTitle: 'Device Information',
          form: {
            deviceName: 'Device Name',
            deviceSerial: 'Device Serial',
            productCode: 'Product Code',
            simNumber: 'Sim Number',
            simProvider: 'Sim Operator',
            rentDate: 'Rent Start',
            rentPeriod: 'Rent Period (Year)',
            rentFinishDate: 'Rent Finish'
          },
          SuccessMessage: 'Device information has been updated.',
          buttons: {
            saveData: 'Save Information',
            extendRental: 'Extend Rental',
            stopRenting: 'Stop Rental'
          },
          extendRental: {
            formYear: 'Year',
            acceptButton: 'Extend Rental',
            successMsg: 'The Rental Period Has Been Extended.'
          },
          stopRental: {
            message: 'Are you sure you want to stop rental?',
            acceptButton: 'Stop Rental',
            successMsg: 'Rental Stopped.'
          }
        },
        new: {
          Title: 'Create Rental',
          steps: {
            step1: 'Renter Information',
            step2: 'Device Information'
          },
          form: {
            RentPeriod: 'Rent Period (Year)',
            RentPeriodPlaceholder: 'Rent Period',
            Device: 'Device',
            SelectDevice: 'Select Device',
            SearchDevice: 'Search Device',
            NoResultDevice: 'The device was not found',
            DeviceCount: 'Number of Devices to be Added',
            NoDeviceError: 'You must add at least one device to create a rental.',
            DuplicateDeviceError: 'More than one cannot be selected from the same device.',
            AddDeviceBtn: 'Add Device',
            AutoFillBtn: 'Auto Fill',
            DeleteBtn: 'Delete',
            SubmitBtn: 'Save',
            NextBtn: 'Next',
            BackBtn: 'Back',
            SuccessMessage: 'The lease has been carried out.',
            WarningMessage: 'There is no device for leasing.'
          }
        }
      }
    },
    myDeviceRentals: {
      tabs: {
        tab1: 'My Active Leases',
        tab2: 'My Expired Leases',
        tab3: 'My Leases Will Expire'
      },
      table: {
        deviceSerial: 'DEVICE SERIAL',
        productCode: 'PRODUCT CODE',
        deviceName: 'DEVICE NAME',
        startDate: 'START DATE',
        endDate: 'END DATE',
        leasedBy: 'LEASED BY',
        actions: 'RENEWAL STATUS'
      },
      ExtendRental: {
        Title: 'Extend Rental',
        WarningMessage: 'Soon we are with you with the \'Extend Rental\' feature.'
      },
      RenewalStatus: {
        Title: 'Renewal Status'
      }
    },
    contactForm: {
      Title: 'Contact Form',
      FirstName: 'First Name',
      LastName: 'Last Name',
      NameSurname: 'Name Surname',
      Email: 'Email',
      Description: 'Description',
      SuccessMessage: 'Your message has been received.'
    },
    help:{
      Title:'Help',
      Header:{
        Title:'Frequently Asked Questions',
        Text:'How can we help you?'
      },
      Questions:{
        Headers:{
          '1':'How do I install the product?',
          '2':'How can I follow my orders?',
          '3':'How do I identify the device to the platform?',
          '4':'What do I do if the product fails?',
          '5':'Where can I find detailed information about product features?',
          '6':'Can I cancel my product?',
          '7':'How do I return the product?',
          '8':'What should I do if my product\'s battery is dead?',
          '9':'What do I do if the product does not work in my area?'
        },
        Answers:{
          Question1:{
            '1':'Turn the on/off button on the electronic board in Hexasense to the \'on\' position.',
            '2':'Fix the product cover with the screws included in the box.',
            '3':'You can fix the product to the frame with clamps and place it inside the hive.'
          },
          Question2:{
            'text':'After receiving your order for product tracking, we send you a cargo tracking number via whatsapp. You can track your order from this number.'
          },
          Question3:{
            '1':'Enter your information in the account creation section and set your password.',
            '2':'Activate your account by clicking the activation link sent to your e-mail address.',
            '3':'Add new apiary from the apiary page.',
            '4':'Specify its name and location, other data will be filled in automatically when location information is selected.',
            '5':'When you press the \'add a new device\' button on the Hives page, enter the product code sent to your e-mail address in the relevant field. All devices will be added automatically.',
            '6':'You can name the devices you want, you can choose apiaries.'
          },
          Question4:{
            'text':'You can contact us by filling out the {button} at the bottom of the platform page.',
            'button':'Contact Form'
          },
          Question5:{
            'text':'You can find detailed information about product features at {button}.'
          },
          Question6:{
            'text':'For cancellation requests, you should contact us at {phone}.'
          },
          Question7:{
            'text':'For product return, you must contact us at {phone}.'
          },
          Question8:{
            'text':'Hexasense guarantees 1 year battery life. If your battery runs out before this time, contact us by filling out the {button}.',
            'button':'Contact Form'
          },
          Question9:{
            'text':'In case of no coverage, please contact us by filling out the {button}.',
            'button':'Contact Form'
          }
        }
      },
      Footer:{
        Title:'You still have a question?',
        Text:'If you cannot find a question in our FAQ, you can always contact us.',
        PhoneCardText:'We are always happy to help!',
        MailCardText:'Best way to get answer faster!'
      }
    },
    errors: {
      404: {
        Title: 'Page Not Found',
        Text: 'Oops! 😖 The requested page was not found on this server.',
        Button: 'Back to platform'
      }
    },
    date: {
      LastHour: 'Previous hour',
      CurrentHour: 'Current hour',
      Today: 'Today',
      Yesterday: 'Yesterday',
      LastWeek: 'Last 7 days',
      LastMonth: 'Last 30 days',
      LastTwoMonth: 'Last 2 months',
      LastFourMonth: 'Last 4 months',
      LastSixMonth: 'Last 6 months',
      LastYear: 'Last 1 years',
      LastTwoYear: 'Last 2 years',
      applyBtn: 'Apply',
      placeholder: 'Select Date Range',
      Title: 'Date'
    },
    search: {
      Text: 'Search'
    },
    table: {
      LoadingText: 'Loading...',
      NoMatch: 'No matching data.',
      NoData: 'Empty List',
      NoDataError: 'There is a problem'
    },
    form: {
      ErrorMessages: {
        Required: 'This field can not be empty.',
        Select:'At least one option must be selected.',
        Numeric: 'This field may only contain numeric characters.',
        Between: 'This field must be between {min} and {max}'
      },
      NoResult: 'No matching data.',
      Empty: 'Empty List',
      Loading: 'Loading...'
    },
    select: {
      NoMatching: 'No matching data.',
      NoData: 'Empty list.'
    },
    buttons: {
      Cancel: 'Cancel',
      Approve: 'Approve',
      Tryagain: 'Try Again',
      Confirm: 'Confirm',
      Save: 'Save',
      Send:'Send'
    },
    notifyAlert: {
      error: {
        title: 'Error!'
      },
      success: {
        title: 'Successful!'
      },
      warning: {
        title: 'Warning!'
      }
    },
    phoneNumberInput: {
      Telephone: 'Phone Number',
      TelephoneCountryCode: 'Country Code',
      TelephoneCountryCodeError: 'Select a Country',
      TelephoneExample: 'Example :',
      errorMsj: {
        FormTelephoneEmpty: 'Phone Number can not be empty.',
        FormTelephoneErr: 'Wrong Phone Number.',
        FormSimEmpty: 'Sim Number can not be empty.',
        FormSimErr: 'Wrong Sim Number.'
      }
    },
    echarts:{
      toolbox:{
        Zoom: 'Zoom',
        ZoomReset: 'Zoom Reset',
        Restore:'Restore',
        SaveAsImage: 'Save as Image'
      }
    }
  },
  tr: {
    profile: {
      Title: 'Profil',
      PasswordUpdated: 'Şifre güncellendi. Lütfen yeni şifreniz ile giriş yapınız.',
      Info: 'Kişisel Bilgiler',
      Admin: 'Yönetici Paneli',
      Settings: 'Hesap Ayarları',
      ChangePassword: 'Şifre Değiştir',
      MyDeviceRentals: 'Cihaz Kiralamalarım',
      Logout: 'Çıkış Yap',
      Accept: 'Kaydet',
      Close: 'Kapat',
      Name: 'Ad{scolon}',
      Username: 'Kullanıcı Adı{scolon}',
      Timezone: 'Saat Dilimi{scolon}',
      language: {
        Title: 'Dil{scolon}',
        Tr: 'Türkçe',
        En: 'İngilizce'
      },
      SelectLanguage: 'Dil Seçiniz',
      OldPassword: 'Eski Şifre{scolon}',
      OldPasswordError: 'Eski şifre boş geçilemez.',
      NewPassword: 'Yeni Şifre{scolon}',
      NewPasswordSec: 'Yeni Şifre Tekrar{scolon}',
      NewPasswordError: 'Yeni şifre boş geçilemez.',
      NewPasswordNoMatch: 'Şifre onay eşleşmiyor.',
      NewPasswordSecError: 'Şifre onay boş geçilemez.',
      Accountsettings: {
        Tab1Title: 'Kullanıcı Ayarları',
        Tab2Title: 'SMS Ayarları',
        Tab3Title: 'Dil Ayarları',
        PhoneWarningMessage: 'SMS bildirimlerini aktifleştirmek için lütfen telefon numaranızı doğrulayınız.',
        ConfirmationCode: 'Onay Kodu',
        ConfirmationCodeMessage: 'Lütfen telefonunuza gelen 6 haneli güvenlik kodunu giriniz.',
        ConfirmationCode404Message: 'Yanlış kod girdiniz.',
        ConfirmationCode400Message: 'Son sms isteğinin süresi dolmadı. Şu an yeni sms talep edemezsiniz.',
        SuccessMessage: 'Hesap bilgileriniz güncellendi.',
        ValidateCodeSuccessMessage: 'Telefon numaranız doğrulandı.',
        MissingCodeError: 'Eksik kod girdiniz.'
      }
    },
    notifications: {
      Title: 'Bildirimler',
      NoMessages: 'Mesajınız bulunmamaktadır.',
      NotificationType: {
        Alarm:'Alarm Bildirimi'
      }
    },
    maintenance:{
      Title:'Bakımda 🛠',
      Text:'Rahatsızlık için özür dileriz ama şu anda biraz bakım yapıyoruz.'
    },
    authFooter: {
      UserAgreement: 'Kullanıcı Sözleşmesi',
      CookiePolicy: 'Çerez Politikası',
      PrivacyPolicy: 'Gizlilik Politikası',
      RentalAgreement: 'Kiralama Sözleşmesi',
      updateText: 'Son Güncelleme tarihi:'
    },
    login: {
      Title: 'Oturum Aç',
      MessageTitle: 'Hexasense\'e tekrar hoş geldiniz! 👋',
      Message: 'Lütfen hesabınız ile giriş yapınız.',
      FormMail: 'E-posta',
      FormMailEmpty: 'E-posta boş geçilemez.',
      FormMailValid: 'Geçerli bir e-posta adresi giriniz',
      FormPassword: 'Şifre',
      FormPasswordEmpty: 'Şifre boş geçilemez',
      FormPhone: 'Telefon Numarası',
      FormPhoneEmpty: 'Telefon Numarası boş geçilemez.',
      FormRemember: 'Beni Hatırla',
      ForgotPassword: 'Parolanızı mı unuttunuz?',
      ForgotPasswordMessage:
        'Lütfen e-posta adresinizi girin, size şifrenizi nasıl sıfırlayacağınızla ilgili talimatlar gönderelim.',
      CreateAnAccount:{
        text:'Platformumuzda yeni misiniz?',
        button:'Kayıt Ol'
      },
      AlreadyHaveAnAccount:{
        text:'Zaten hesabınız var mı.',
        button:'Giriş Yap'
      },
      BackToLogin:'Girişe geri dön',
      SignUp: 'Kayıt Ol',
      Login: 'Giriş Yap',
      SavePassword: 'Şifre Kurtar',
      LoggedIn: 'Hoş Geldiniz!',
      reset: {
        Title: 'Şifreyi Yenile',
        NewPassword: 'Lütfen yeni şifrenizi giriniz.',
        ResetPassword: 'Şifre Yenile'
      },
      ConfirmPhoneNumberText: 'SMS Bildirimleri alabilmek için telefon numaranızı sisteme kaydetmeniz gerekmektedir.'
    },
    register: {
      Title: 'Hesap Oluştur',
      Message: 'Yeni bir hesap oluşturmak için aşağıdaki formu doldurun.',
      FormPasswordLength: 'Şifre uzunluğu en az {length} karakter olmalıdır.',
      FirstName: 'Ad',
      FormFirstNameEmpty: 'Ad boş geçilemez',
      LastName: 'Soyad',
      FormLastNameEmpty: 'Soyad boş geçilemez',
      ConfirmPassword: 'Şifreyi Onayla',
      FormPConfirmPasswordEmpty: 'Şifre Onay boş geçilemez',
      PasswordNoMatch: 'Şifreler eşleşmiyor',
      TermsAndCondsOk: {
        text: 'Kayıt olarak {policyButton1} okuduğunuzu ve kabul ettiğinizi onaylıyorsunuz. Kişisel verilerinizin işlenmesine ilişkin olarak lütfen {policyButton2} ve {policyButton3} Politikasını inceleyiniz.',
        policyButton1: 'Kullanıcı Sözleşmesini',
        policyButton2: 'Gizlilik',
        policyButton3: 'Çerez',
        acceptText:'Yukarıda yer alan Kullanıcı Sözleşmesi hakkındaki Aydınlatma metnini okudum, Kullanıcı Sözleşmesinin ne şekilde işleneceği konusunda bilgi sahibi oldum.'
      },
      TermsAndCondsOkBtn: 'Kabul Et',
      FormTermsConditionAccepted: 'Lütfen Kullanıcı Sözleşmesini onaylayınız.',
      ModalSuccess: {
        Title: 'Başarılı!',
        Text:
          'Kullanıcı başarılı bir şekilde kaydedilmiştir. Lütfen hesabınızı aktifleştirmek için mail adresinizi kontrol ediniz.'
      },
      ModalFail: {
        Title: 'Hata!'
      },
      activated: {
        Welcome: 'Hoş Geldiniz',
        RedirectRegister: {
          text: 'Lütfen kayıt ol sayfasına gitmek için {button} tıklaynız.',
          button: 'buraya'
        },
        RedirectLogin: {
          text: 'Lütfen platforma giriş yapabilmek için {button} tıklaynız.',
          button: 'buraya'
        },
        success: {
          title: 'Hesabınız aktif edilmiştir.',
          text: 'Giriş sayfasına yönlendiriliyorsunuz, lütfen bekleyiniz.'
        }
      }
    },
    messagebox: {
      ErrorMsg: 'Bir hata oluştu. Lütfen tekrar deneyiniz.',
      NotAllowedError:
        'Hey! Kameranıza erişmem gerekiyor, lütfen devam etmesine izin verin.',
      NotFoundError: 'Cihazınız bir kameraya sahip mi?',
      NotSupportedError: 'Görünüşe göre bu sayfa güvenli değil',
      InsecureContextError:
        'Kamera erişimine yalnızca güvenli bağlamda izin verilir. HTTP yerine HTTPS veya localhost kullanın.',
      NotReadableError: 'Kameranıza erişilemedi. Zaten kullanılıyor mu?',
      OverconstrainedError:
        'Constraints don\'t match any installed camera. Did you asked for the front camera although there is none?',
      ECONNABORTED:
        'Api isteği zaman aşımına uğradı. Lütfen daha sonra tekrar deneyiniz.',
      RegisterError: 'Bu e-posta adresi ile kayıtlı zaten bir kullanıcı bulunmaktadır.',
      AlreadyApiary: 'Bu isimde bir arı kovanı zaten var.',
      WrongActivationCode: 'Aktivasyon kodunuz yanlış. Lütfen size iletmiş olduğumuz aktivasyon mailini kontrol ediniz.',
      88: 'Qr kod boş geçilemez',
      89: 'Bu telefon coğrafi konumu desteklemiyor.',
      90: 'Okutmuş olduğunuz QR kod HexaSense ait bir cihaz değil.',
      98: 'Oturum süreniz sona erdi. Lütfen giriş yapın.',
      99: 'Platforma erişim izniniz yok. Lütfen giriş yapın.',
      100: 'Sunucu Hatası',
      101: 'Lütfen formu doldurunuz.',
      102: 'Şifreler uyuşmuyor.',
      105: 'Lütfen Hexasense şart ve koşullarını kabul ediniz.',
      400: 'Geçerli bir seçim seçin. Bu seçim mevcut seçeneklerden biri değil.',
      500: 'İç Sunucu Hatası',
      404: 'İstenen kaynak mevcut değil',
      409: 'İstenen kaynak var',
      401: 'Token geçersiz veya süresi dolmuş',
      1000: 'Bu cihaz zaten kayıtlı',
      1002: 'Bu cihaz zaten kullanıcıya atanmıştır',
      1003: 'Cihaz token uyuşmamaktadır',
      1004: 'Cihaz bulunamadı',
      1005: 'Bu cihaz zaten aktif',
      1006: 'Cihaz aktivasyonuna izin verilmiyor',
      1007: 'Cihaz aktif değil.',
      4000: 'Parametreler gerekli',
      4001: 'Eski şifreniz yanlış. Lütfen eski şifrenizi kontrol ediniz.',
      4002: 'Bu e-posta adresi ile kayıtlı bir kullanıcı bulunmamaktadır.',
      4003: 'Bu e-posta adresi ile kayıtlı zaten bir kullanıcı bulunmaktadır.',
      4004: 'Bu kullanıcı zaten etkin.',
      4005: 'Aktivasyon süreniz dolmuştur. Lütfen yeni bir aktivasyon maili isteyiniz.',
      4030: 'Şifre yenilemek için size verdiğimiz süre dolmuştur. Lütfen yeni bir istekte bulununuz. ',
      4031: 'Geçersiz şifre yenileme isteği. Lütfen yeni bir bağlantı isteyiniz. ',
      4080: 'Verilen kimlik bilgilerine sahip bir hesap bulunamadı.',
      4081: 'Hesabınızı aktif etmeniz gerekmektedir.',
      4082: 'Lütfen giriş bilgilerinizin doğruluğunu kontrol ediniz.',
      2001: 'E-posta adresinize şifre sıfırlamak için bir mail gönderilmiştir. Lütfen e-posta adresinizi kontrol ediniz.',
      2002: 'Şifreniz başarılı bir şekilde güncellenmiştir. Lütfen yeni şifrenizle giriş yapınız.',
      2003: 'Hesabınız aktif edilmiştir.',
      6001:'Kovanınıza ait konum bilgisine ulaşılamadı.'
    },
    sidebar: {
      Homepage: 'Ana Sayfa',
      Apiaries: 'Arılıklar',
      Hives: 'Kovanlar',
      Warnings: 'Alarmlar',
      Rules: 'Kurallar'
    },
    breadcrumbs: {
      HiveFromQr: 'Yeni Kovan Ekle / QR Code',
      HiveWithId: 'Kovanlar / Kovan {n}',
      EditRule: 'Kural Düzenle',
      ShowRule: 'Kural Görüntüle'
    },
    homepage: {
      cards: {
        DeviceInfoName: 'Cihaz Bilgileri',
        RentalInfoName: 'Kiralama Bilgileri',
        Apiary: 'Toplam Arılık',
        Hives: 'Kovanlar',
        TotalHives: 'Toplam Kovan',
        HealthyHivesCount: 'Sağlıklı Kovan',
        MotionDetection: 'Hareket Tespiti',
        Alarms: 'Alarmlar',
        InactiveRents: 'Süresi Bitmiş',
        UpcomingRentals: 'Süresi Bitecek'
      },
      weather: {
        Title: 'Hava Durumu',
        TakingWeatherForecast: 'Hava durumu alınıyor...',
        ApiaryNotFound: 'Hava durumu için kayıtlı "Arılık" bulunmamaktadır',
        Modal: {
          GetFail: 'Beklenmeyen Hata! Hava durumu alınamadı.'
        }
      },
      map: {
        noData: 'Kullanıcıya ait arılık bulunmamaktadır.'
      },
      NotHiveWarningMessage: 'Görünüşe göre henüz kovanınız yok. Ürün Anahtarına sahipseniz yeni kovan ekleyiniz.',
      NotApiaryWarningMessage: 'Görünüşe göre henüz arılığınız yok. Arılıklar sayfasından arılık ekleyiniz.'
    },
    apiaries: {
      AddNewApiary: 'Yeni Arılık Ekle',
      AddApiary: 'Arılık Ekle',
      LastUpdate: 'Son Güncelleme',
      SelectApiary: 'Arılık Seçiniz',
      filters: {
        UserOrCompany: 'Arıcı veya Firma',
        UserPlaceholder: 'Arıcı veya Firma Seçiniz',
        NoResult: 'Eşleşen bir öğe bulunamadı',
        Empty: 'Liste Boş',
        Company: 'Firma',
        CompanyPlaceholder: 'Firma seçiniz'
      },
      FiltersMsg: 'Bu kullanıcıya ait arılık bulunmamaktadır.',
      UserNotApiaryMessage:'Kullanıcınıza ait arılık bulunmamaktadır. Şu an sadece diğer kullanıcılara ait arılıkları görüntülemektesiniz.',
      Latitude:'Enlem',
      Longitude:'Boylam',
      new: {
        ApiaryName: 'Arılık Adı',
        Required: 'Bu kısım boş geçilemez.',
        Date: 'Tarih',
        SearchLocation: 'Haritada konum ara',
        Country: 'Ülke',
        City: 'Şehir',
        District: 'İlçe',
        Save: 'Kaydet',
        Humidity: 'Nem',
        Temperature: 'Sıcaklık',
        SuccessAddMessage: 'Yeni arılık başarılı bir şekilde kaydedildi.'
      },
      ApiaryDetail: 'Arılık Detay',
      DeleteApiary: 'Arılığı Sil',
      EditApiary: 'Arılığı Düzenle',
      detail: {
        Hive:'Kovan',
        Alarms:'Alarmlar',
        InternalTemperature: 'İç Sıcaklık',
        Average:'Ortalama',
        TheHottest:'En Sıcak',
        TheColdest: 'En Soğuk',
        MostHumid:'En Nemli',
        TheHeaviest: 'En Ağır',
        Weight:'Ağırlık',
        Last15Days:'Son 15 Gün',
        StatisticsCardInfo:'Kovanlardan gelen verilere göre.'
      },
      edit: {
        EditApiaries: 'Arılık Düzenle',
        ApiaryEdited: 'Arılık başarılı bir şekilde düzenlendi.'
      },
      delete: {
        DeleteMessage:
          '<strong>{name}</strong>  arılığı için silme işlemi yapmaktasınız. Silme işlemini onayladıktan sonra <strong>{name}</strong> arılığına ait tüm bilgiler silinecektir. ',
        Proceed:
          'Devam etmek istiyorsanız <strong>"İşleme Devam Et"</strong> butona basınız.',
        ProceedButton: 'İşleme Devam Et',
        DeleteApiary: 'Arılık Sil',
        ConfirmDelete: 'Arılığı silmek istiyor musunuz?',
        CancelButton: 'İptal',
        ApiaryDeleted: 'Arılık Silindi'
      },
      allApiaries: 'Tüm Arılıklar',
      myApiaries: 'Kendi Arılıklarım',
      selectedApiary: 'Seçili Arılıklar'
    },
    hives: {
      NoApiary:
        'Yeni bir kovan ekleyebilmeniz için en az bir arılığınızın bulunması gerekmektedir.',
      AddApiaryMessage: 'Lütfen ilk önce yeni bir arılık ekleyiniz.',
      CreateNewHive: 'Yeni Kovan Oluştur',
      CreateHive: 'Kovan Oluştur',
      AddDevice: 'Yeni Cihaz Ekle',
      HiveDetail: 'Kovan Detay',
      HiveOnline: 'Online',
      HiveOffline: 'Offline',
      Bee:'Arı',
      BeeAge:'{age} aylık',
      UserNotApiaryMessage:'Kullanıcınıza ait kovan bulunmamaktadır. Şu an sadece diğer kullanıcılara ait kovanları görüntülemektesiniz. Kendinize ait kovan oluşturmak için öncelikle arılık eklemeniz gerekmektedir.',
      UserNotHiveMessage:'Kullanıcınıza ait kovan bulunmamaktadır. Şu an sadece diğer kullanıcılara ait kovanları görüntülemektesiniz.',
      delete: {
        Title: 'Kovan Sil',
        DeleteMessage:
          '<strong>{name}</strong>  kovanı için silme işlemi yapmaktasınız. Silme işlemini onayladıktan sonra <strong>{name}</strong> kovanına ait tüm bilgiler silinecektir. ',
        ConfirmDelete: 'Kovanı silmek istiyor musunuz?',
        Delete: 'Sil',
        SuccessMessage: 'Kovan Silindi.'
      },
      ClearBtn: 'Temizle',
      FiltersMsg: 'Bu kullanıcıya ait kovan bulunmamaktadır.',
      ApiaryFiltersMsg: 'Bu arılığa ait kovan bulunmamaktadır.',
      Myhive: 'Kendi Kovanlarım',
      Imei: {
        CopySuccessMessage: 'Imei başarıyla kopyalandı.',
        CopySErrorMessage: 'Imei kopyalanırken bir hata oluştu..'
      },
      detail:{
        EditHive: 'Kovanı Düzenle',
        DeleteHive: 'Kovanı Sil',
        ViewCharts:'Grafikleri Görüntüle',
        HiveType: 'Kovan Tipi',
        QueenBee: 'Ana Arı',
        Alarm: 'Alarm',
        InstallationDate: 'Kurulum Tarihi',
        Apiary:'Arılık',
        Temperature: 'Sıcaklık',
        Humidity: 'Nem',
        Weight:'Ağırlık',
        Today:'Bugün',
        InTheLastData:'Son Verideki',
        AverageOver24Hours: '24 Saatteki Ortalama',
        BatteryStatus: 'Pil Durumu',
        SignalPower: 'Sinyal Gücü',
        DeviceSerial: 'Cihaz Seri No',
        Sickness:'Hastalık',
        NoteMessage:'Kovana eklemiş olduğunuz notlara göre',
        LastFeed: 'Son Besleme',
        LastDisinfection: 'Son İlaçlama',
        WeatherForecast: 'Hava Durumu',
        AddDevice: 'Cihaz Ekle',
        NoDeviceMessage: 'Kovana takılı cihaz bulunmamaktadır.',
        NoAlarm: 'Alarm bulunmamaktadır.',
        NotAvailable: 'Bulunmamaktadır',
        NoDisease: 'Hastalık Yok',
        charts:{
          Humidity: 'Nem',
          Temperature: 'Sıcaklık',
          Weight: 'Ağırlık',
          NoChartDataMessage:{
            Humidity: 'Bu iki tarih arasında kovana ait nem bilgisi bulunmamaktadır.',
            Temperature: 'Bu iki tarih arasında kovana ait sıcaklık bilgisi bulunmamaktadır.',
            Weight: 'Bu iki tarih arasında kovana ait ağırlık bilgisi bulunmamaktadır.'
          },
          BroodZone: 'Kuluçka Bölgesi',
          titles: {
            Humidity: 'Nem {p}',
            InternalHumidity: 'İç Nem {p}',
            ExternalHumidity: 'Dış Nem {p}',
            Temperature: 'Sıcaklık {p}',
            InternalTemperature: 'İç Sıcaklık {p}',
            ExternalTemperature: 'Dış Sıcaklık {p}',
            Weight: 'Ağırlık {p}'
          }
        }
      },
      Device: {
        Title: 'Cihaz',
        SelectDevice: 'Cihaz Seçiniz',
        NoDevice: 'Bağlı cihaz yok',
        EmptyWarningMessage: 'Bu kullanıcıya ait cihaz bulunmamaktadır.',
        new: {
          Welcome: 'Hoş Geldiniz,',
          WelcomeMessage:
            'Cihaz kiralama işleminizi yaptıktan sonra size mail ile iletmiş olduğumuz <b>"Ürün Anahtarını"</b> ile cihazınızı ekleyebilirsiniz.',
          ProductKey: 'Ürün Anahtarı',
          ProductKeyLengthError: 'Ürün anahtarını eksik girdiniz.',
          Start: 'Başla',
          TCIdentityNumber: 'TC Kimlik Numarası',
          FormTCIdentityNumberError: 'Geçerli bir TC Kimlik Numarası giriniz.',
          Address: 'İkametgah Adresi',
          CheckCheckboxText: 'Girdiğim bilgilerin doğruluğunu teyit ederim.',
          CheckCheckboxError: 'Lütfen bilgilerinizi onaylayınız.',
          RentalConfirmWarningMessage: 'Cihaz eklemek için Kiralama Sözleşmesini kabul etmelisiniz.',
          SuccessMessage: 'Cihaz başarılı bir şekilde kaydedildi.'
        }
      },
      new: {
        User: 'Kullanıcı',
        Code: 'Ürün Kodu',
        Serial: 'Seri No',
        Apiary: 'Arılık',
        SelectApiary: 'Arılık Seçiniz',
        NoResult: 'Eşleşen bir öğe bulunamadı',
        Empty: 'Liste Boş',
        Required: 'Lütfen bir arılık seçiniz',
        RequiredUser: 'Lütfen bir kullanıcı seçiniz',
        Name: 'Kovan Adı',
        QueenBeeDateOfBirth: 'Ana Arı Doğum Tarihi',
        BeeType: 'Arı Tipi',
        SelectBeeType: 'Arı Tipi Seçiniz',
        HiveType: 'Kovan Tipi',
        SelectHiveType: 'Kovan Tipi Seçiniz',
        CancelButton: 'İptal',
        Save: 'Kaydet',
        SuccessMessage: 'Kovan başarılı bir şekilde kaydedildi.',
        ScanQrCode: 'QR Kod Tarat',
        AddWithProductCode: 'Ürün Kodu ve Seri No ile Ekle',
        AddWithProductCodeForm:
          'Lütfen aşağıda verilen formu eksiksiz bir şekilde doldurunuz.',
        CameraMessage:
          'Yeni cihaz eklemeden önce <b>\'Kamera\'</b> izini vermeniz gerekiyor.',
        QrStepOne:
          'Gerekli izinleri verdikten sonra kamera açılıcak. Daha sonra cihazınızın üzerinde bulunan <b>\'QR Kod\'</b> bölümünü kameraya okutunuz.',
        QrStepTwo:
          'Okutulan QR kodu <b>HexaSense</b> cihazına ait ise cihaz ekleme sayfasına yönlendirileceksiniz.'
      },
      edit: {
        EditHives: 'Kovan Düzenle',
        WarningMessage: 'Kovan detaylarını görebilmek için lütfen kovan bilgilerini güncelleyiniz.',
        SuccessMessage: 'Kovan başarılı bir şekilde düzenlendi.',
        UserNoApiary: 'Lütfen kullanıcınızdan arılık eklemesini isteyiniz.',
        NoApiary: {
          text: 'Arılık eklemek için {button} tıklaynız.',
          button: 'buraya'
        }
      },
      signal: {
        Weak: 'Zayıf',
        Middle: 'Orta',
        Strong: 'Güçlü'
      },
      battery: {
        Low: 'Zayıf',
        Normal: 'Normal'
      },
      allHives: 'Tüm Kovanlar'
    },
    hivenote: {
      Title: 'Kovan Notlarım',
      AddNote: 'Not Ekle',
      AddNewNote: 'Yeni Not Ekle',
      PageButton: 'Notlarım',
      table: {
        Device: 'İLGİLİ KOVAN',
        Date: 'NOT TARİHİ',
        Type: 'NOT TİPİ',
        Action: 'İŞLEM'
      },
      new: {
        Title: 'Kovan İçin Not Ekle',
        form: {
          device: 'Kovan',
          actionDate: 'İşlem Tarihi',
          actions: 'İşlem',
          actionNote: 'İşlem Notu',
          note: 'Not',
          frameCount:'Çerçeve Sayısı'
        },
        FrameCountErrorMessage:'Bu alan yalnızca sayısal karakterler içerebilir. Lütfen 0 ile 48 arasında bir değer girin.',
        SelectActionDate: 'İşlem Tarihini Seçiniz',
        SelectAction: 'Aksiyon Seçiniz',
        SelectDevice: 'Kovan Seçiniz',
        SuccessMessage: 'Kovan için note oluşturuldu.',
        SwitchLeft:'Kovanlara',
        SwitchRight:'Arılıklara'
      },
      edit: {
        Title: 'Notu Düzenle',
        SuccessMessage: 'Not Güncellendi.'
      },
      delete: {
        Title: 'Notu Sil',
        WarningMessage: 'Notu silmek istiyor musunuz?',
        SuccessMessage: 'Not Silindi.'
      },
      show: {
        Title: 'Notu Görüntüle'
      }
    },
    rules: {
      main: {
        AddRule: 'Yeni Kural Ekle',
        thead: {
          Name: 'KURAL ADI',
          Rules: 'BAĞLI KURALLAR',
          ApiaryCount: 'BAĞLI ARILIK SAYISI',
          NotificationType: 'BİLDİRİM SEÇENEKLERİ',
          Actions: 'AKSİYONLAR'
        },
        NoRules: 'Kayıtlı kural bulunmamaktadır.',
        NotificationSettingsTooltips: {
          Sms: 'SMS Bildirimi Açık',
          Email: 'E-posta Bildirimleri Açık',
          Platform: 'Platform Bildirimleri Açık'
        }
      },
      new: {
        Name: 'Kural Adı',
        AllApiaries: 'Tüm Arılıklar',
        ApiariesPlaceholder: 'Arılık Seçiniz',
        RequiredApiaries: 'Lütfen en az bir Arılığı seçiniz.',
        RequiredRules: 'Lütfen en az bir Kuralı seçiniz.',
        RequiredNotificationType: 'Lütfen en az bir Bildirim Türünü seçiniz.',
        NotificationSettingsTitle: 'Bildirim Ayarları',
        AlarmSettingsTitle: 'Alarm Ayarları',
        ApiarySettingsTitle: 'Arılık Ayarları',
        ApplyNewApiariesCheckbox: 'Yeni oluşturulan arılıklar için bu kuralı uygula',
        RequiredApiary: 'Yeni bir kural ekleyebilmeniz için en az bir arılığınızın bulunması gerekmektedir.',
        AllSelectedApiaryMessage:'Tüm arılıklarınız için tanımlanmış bir kural bulunmaktadır. Yeni bir kural eklemek için lütfen arılık ekleyin.', 
        AddApiary: 'Lütfen ilk önce yeni bir arılık ekleyiniz.',
        NoSelectApiaryTootltip: 'Bu arılık başka bir kuralla ilişkilendirilmiştir.',
        DataTypeOptions: {
          Temperature: 'Sıcaklık',
          Humidity: 'Nem',
          Vibration: 'Titreşim'
        },
        DataTypeRule: {
          Temperature: {
            text: 'Sıcaklık değeri {min}°C dereceden küçük ve/veya {max}°C dereceden büyük ise alarm oluştur.',
            min: '',
            max: ''
          },
          Humidity: {
            text: 'Nem değeri {min}% dan/den küçük ve/veya {max}% dan/den büyük ise alarm oluştur.',
            min: '',
            max: ''
          },
          Vibration: 'Titreşim oluştuğunda alarm oluştur.'
        },
        DataNotificationsOptions: {
          Web: 'Platform üzerinden almak istiyorum',
          Mail: 'E-posta ile almak istiyorum',
          Sms:'SMS ile almak istiyorum'
        },
        SelectAllApiaryBtn: 'Tüm Arılıkları Seç',
        ClearBtn: 'Temizle',
        SuccessAddMessage: 'Yeni kural başarıyla eklendi'
      },
      edit: {
        Title: 'Arılık',
        SuccessMessage: 'Kural başarıyla düzenlendi.'
      },
      delete: {
        Title: 'Kural Sil',
        DeleteMessage:
          '<strong>{name}</strong>  kuralı için silme işlemi yapmaktasınız. Silme işlemini onayladıktan sonra <strong>{name}</strong> kuralına ait tüm bilgiler silinecektir. ',
        Proceed:
          'Devam etmek istiyorsanız <strong>"İşleme Devam Et"</strong> butona basınız.',
        ProceedButton: 'İşleme Devam Et',
        DeleteQuestion: 'Kuralı silmek istiyor musunuz?',
        Deleted: 'Kural Silindi.'
      },
      formErrors: {
        MaxMin: 'İkinci değer birinci değerden küçük olmaz.',
        MaxMinEmpty: 'Değerlerden en az birini belirtmeniz gerekiyor.',
        MaxMinMatch: 'İki değer aynı olamaz.'
      }
    },
    alarms: {
      thead: {
        RelatedHive: 'İLGİLİ KOVAN',
        RelatedApiary: 'İLGİLİ ARILIK',
        DataType: 'VERİ TÜRÜ',
        MeasuredValue: 'ÖLÇÜLEN DEĞER',
        CreatedAt: 'OLUŞMA ZAMANI',
        Actions: 'AKSİYONLAR'
      },
      DeleteModalTitle: 'Alarm Sil',
      DeclaredRules: 'Tanımlı Kurallar',
      DeleteAlarmQuestion: 'Alarmı silmek istiyor musunuz?',
      ButtonClose: 'Kapat',
      ButtonDelete: 'Sil',
      NoAlarm: 'Kayıtlı alarm bulunmamaktadır.',
      Loading: 'Yükleniyor...',
      NoDataError: 'Bir sorun oluştu.',
      DeleteSuccess: 'Alarm silindi.',
      NoMatchingData: 'Eşleşen alarm bulunamadı.',
      allAlarms: 'Tüm Alarmlarım'

    },
    admin: {
      Title: 'Yönetici Paneli',
      tab: {
        user: 'Kullanıcı Yönetimi',
        device: 'Cihaz Yönetimi'
      },
      AddUser: 'Yeni Kullanıcı Ekle',
      thead: {
        User: 'KULLANICI',
        Role: 'ROL',
        Actions: 'AKSİYONLAR'
      },
      NoMatchingData: 'Eşleşen veri bulunamadı.',
      NoDataError: 'Bir sorun oluştu.',
      NoUser: 'Kayıtlı kullanıcı bulunmamaktadır.',
      Loading: 'Yükleniyor...',
      newUserModal: {
        Title: 'Yeni Kullanıcı',
        form: {
          Email: 'E-posta',
          FormMailEmpty: 'E-posta boş geçilemez.',
          FormNameEmpty: 'Ad boş geçilemez.',
          FormSurnameEmpty: 'Soyad boş geçilemez.',
          FormCompanyEmpty: 'Firma boş geçilemez.',
          FormTelephoneEmpty: 'Telefon Numarası boş geçilemez.',
          FormTelephoneErr: 'Yanlış Telefon Numarası.',
          Password: 'Şifre',
          Company: 'Firma',
          Name: 'Ad',
          Surname: 'Soyad',
          Telephone: 'Telefon Numarası',
          TelephoneCountryCode: 'Ülke Kodu',
          TelephoneCountryCodeError: 'Bir ülke seçiniz',
          TelephoneExample: 'Örneğin :'

        },
        SuccessMessage: 'Kullanıcı oluşturuldu!',
        SuccessMessageText: 'Kullanıcı bilgileri kullanıcıya iletildi.'
      },
      deleteUserModal: {
        Title: 'Kullanıcı Silme',
        WarningMessage: 'Bu kullanıcıya ait bütün bilgiler silinecektir. Kullanıyıcı silmek istiyor musunuz?',
        SuccessMessage: 'Kullanıcı silindi.',
        NoDataError: 'Bir sorun oluştu.'
      },
      copyPassword: {
        Success: 'Şifre başarıyla kopyalandı',
        Error: 'Şifre kopyalanamadı'
      },
      roles: {
        Manager: 'Yönetici',
        User: 'Kullanıcı'
      },
      panelErrorMess: 'Yönetici Paneline giriş yetkiniz bulunmamaktadır.',
      errorCode: {
        400: 'Bu e-postaya sahip kullanıcı zaten var.',
        500: 'İç Sunucu Hatası.(500)'
      },
      allUsers: 'Tüm Kullanıcılar',
      devices: {
        NoDevice: 'Kayıtlı cihaz bulunmamaktadır.',
        table: {
          deviceSerial: 'CİHAZ SERİ NUMARASI',
          productCode: 'ÜRÜN KODU',
          simNumber: 'SİM NUMARASI',
          simProvider: 'SİM OPERATÖRÜ',
          rentalStatus: 'KİRALAMA DURUMU',
          rentDate: 'KİRALAMA BAŞLANGIÇ TARİHİ',
          rentPeriod: 'KİRALAMA SÜRESİ (YIL)',
          rentFinishDate: 'KİRALAMA BİTİŞ TARİHİ',
          actions: 'AKSİYONLAR'
        },
        CreateRentalBtn: 'Kiralama Oluştur',
        chip: {
          passive: 'Pasif',
          active: 'Aktif'
        },
        actionEditButton: 'Düzenle',
        filters: {
          rented: {
            all: 'Tümü',
            rented: 'Kiralandı',
            notRented: 'Kiralanmamış'
          }
        },
        edit: {
          Title: 'Cihaz Düzenle',
          cardTitle: 'Cihaz Bilgileri',
          form: {
            deviceName: 'Cihaz Adı',
            deviceSerial: 'Cihaz Seri Numarası',
            productCode: 'Ürün Kodu',
            simNumber: 'Sim Numarası',
            simProvider: 'Sim Operatörü',
            rentDate: 'Kiralama Başlangıç Tarihi',
            rentPeriod: 'Kiralama Süresi (YIL)',
            rentFinishDate: 'Kiralama Bitiş Tarihi'
          },
          SuccessMessage: 'Cihaz bilgileri güncellendi.',
          buttons: {
            saveData: 'Bilgileri Kaydet',
            extendRental: 'Kiralamayı Uzat',
            stopRenting: 'Kiralamayı Durdur'
          },
          extendRental: {
            formYear: 'Yıl',
            acceptButton: 'Kiralamayı Uzat',
            successMsg: 'Kiralama Süresi Uzatıldı.'
          },
          stopRental: {
            message: 'Kiralamayı durdurmak istediğinizden emin misiniz?',
            acceptButton: 'Kiralamayı Durdur',
            successMsg: 'Kiralama Durduruldu.'
          }
        },
        new: {
          Title: 'Kiralama Oluştur',
          steps: {
            step1: 'Kiralayan Bilgileri',
            step2: 'Cihaz Bilgileri'
          },
          form: {
            RentPeriod: 'Kiralama Süresi (YIL)',
            RentPeriodPlaceholder: 'Kiralama Süresi',
            Device: 'Cihaz',
            SelectDevice: 'Cihaz Seçiniz',
            SearchDevice: 'Cihaz Ara',
            NoResultDevice: 'Cihaz bulunamadı',
            DeviceCount: 'Eklenecek Cihaz Sayısı',
            NoDeviceError: 'Kiralama oluşturmak için en az bir cihaz eklemelisiniz.',
            DuplicateDeviceError: 'Aynı cihazdan birden fazla seçilemez.',
            AddDeviceBtn: 'Cihaz Ekle',
            AutoFillBtn: 'Otomatik Doldur',
            DeleteBtn: 'Sil',
            SubmitBtn: 'Kaydet',
            NextBtn: 'İleri',
            BackBtn: 'Geri',
            SuccessMessage: 'Kiralama işlemi gerçekleştirildi.',
            WarningMessage: 'Kiralama için cihaz bulunmamaktadır.'
          }
        }
      }
    },
    myDeviceRentals: {
      tabs: {
        tab1: 'Aktif Kiralamalarım',
        tab2: 'Süresi Bitmiş Kiralamalarım',
        tab3: 'Süresi Bitecek Kiralamalarım'
      },
      table: {
        deviceSerial: 'CİHAZ SERİ NUMARASI',
        productCode: 'ÜRÜN KODU',
        deviceName: 'CİHAZ ADI',
        startDate: 'BAŞLANGIÇ TARİHİ',
        endDate: 'BİTİŞ TARİHİ',
        leasedBy: 'KİRALAMAYI YAPAN',
        actions: 'YENİLENME DURUMU'
      },
      ExtendRental: {
        Title: 'Kiralamayı Uzat',
        WarningMessage: 'Yakında \'Kiralamayı Uzat\' özelliği ile sizlerleyiz.'
      },
      RenewalStatus: {
        Title: 'Yenilenme Durumu'
      }
    },
    contactForm: {
      Title: 'İletişim Formu',
      FirstName: 'Ad',
      LastName: 'Soyad',
      Email: 'E-posta',
      Description: 'Açıklama',
      SuccessMessage: 'Mesajınız alınmıştır.'
    },    
    help:{
      Title:'Yardım',
      Header:{
        Title:'Sıkça Sorulan Sorular',
        Text:'Size nasıl yardımcı olabiliriz?'
      },
      Questions:{
        Headers:{
          '1':'Ürün kurulumunu nasıl yaparım?',
          '2':'Siparişlerimi nasıl takip edebilirim?',
          '3':'Platforma cihazı nasıl tanımlarım?',
          '4':'Ürünün arızalanması durumunda ne yaparım?',
          '5':'Ürün özellikleriyle ilgili detaylı bilgiye nereden ulaşırım?',
          '6':'Ürünümü iptal edebilir miyim?',
          '7':'Ürünü nasıl iade ederim?',
          '8':'Ürünümün pili biterse ne yapmalıyım?',
          '9':'Bulunduğum bölgede ürün çalışmıyorsa ne yapacağım?'
        },
        Answers:{
          Question1:{
            '1':'Hexasense içindeki elektronik kartta bulunan on/off düğmesini \'on\' konumuna getirin.',
            '2':'Kutu içerisinde bulunan vidalar ile ürün kapağını sabitleyin.',
            '3':'Ürünü, kelepçeler ile çerçeveye sabitleyip kovan içine yerleştirebilirsiniz.'
          },
          Question2:{
            'text':'Ürün takibi için siparişinizi aldıktan sonra whatsapptan size kargo takip numarası göndermekteyiz. Bu numaradan siparişinizi takip edebilirsiniz.'
          },
          Question3:{
            '1':'Hesap oluşturma bölümünden bilgilerinizi girip şifrenizi belirleyin.',
            '2':'E-posta adresinize gelen aktivasyon linkine tıklayarak hesabınızı aktifleştirin.',
            '3':'Arılık sayfasından yeni arılık ekleyin.',
            '4':'İsmini ve konumunu belirleyin, konum bilgisi seçildiğinde diğer veriler otomatik olarak doldurulur.',
            '5':'Kovanlar sayfasındaki \'yeni cihaz ekle\' butonuna bastığınızda mail adresinize gelen ürün kodunu ilgili alana girin. Otomatik olarak tüm cihazlar eklenecektir.',
            '6':'Cihazlara dilediğiniz ismi verebilir, arılık seçimlerini yapabilirsiniz.'
          },
          Question4:{
            'text':'Platform sayfasında en alt kısımda bulunan {button}\'nu doldurarak bizimle iletişime geçebilirsiniz.',
            'button':'İletişim Formu'
          },
          Question5:{
            'text':'Ürün özellikleri ile ilgili detaylı bilgiye, {button} adresinden ulaşabilirsiniz.'
          },
          Question6:{
            'text':'İptal talebi için {phone} nolu telefondan bizimle iletişime geçmeniz gerekmektedir.'
          },
          Question7:{
            'text':'Ürün iade işlemi için {phone} nolu telefondan bizimle iletişime geçmeniz gerekmektedir.'
          },
          Question8:{
            'text':'Hexasense, 1 yıllık pil ömrü garanti etmektedir. Pilinizin bu süreden önce bitmesi durumunda {button}\'nu doldurarak bizimle iletişime geçin.',
            'button':'İletişim Formu'
          },
          Question9:{
            'text':'Kapsama alanı olmaması durumunda lütfen {button}\'nu doldurarak bizimle iletişime geçiniz.',
            'button':'İletişim Formu'
          }
        }
      },
      Footer:{
        Title:'Hala bir sorunuz mu var?',
        Text:'SSS\'imizde bir soru bulamazsanız, her zaman bizimle iletişime geçebilirsiniz.',
        PhoneCardText:'Yardım etmekten her zaman mutluluk duyarız!',
        MailCardText:'Daha hızlı yanıt almanın en iyi yolu!'
      }
    },
    errors: {
      404: {
        Title: 'Sayfa Bulunamadı',
        Text: 'Oops! 😖 İstenen sayfa bu sunucuda bulunamadı.',
        Button: 'Platforma Geri Dön'
      }
    },
    date: {
      LastHour: 'Geçmiş 1 saat',
      CurrentHour: 'Şu anki saat',
      Today: 'Bugün',
      Yesterday: 'Dün',
      LastWeek: 'Son 7 gün',
      LastMonth: 'Son 30 gün',
      LastTwoMonth: 'Son 2 ay',
      LastFourMonth: 'Son 4 ay',
      LastSixMonth: 'Son 6 ay',
      LastYear: 'Son 1 yıl',
      LastTwoYear: 'Son 2 yıl',
      applyBtn: 'Uygula',
      placeholder: 'Tarih Aralığını Seçiniz',
      Title: 'Tarih'
    },
    search: {
      Text: 'Ara'
    },
    table: {
      LoadingText: 'Yükleniyor...',
      NoMatch: 'Eşleşen veri yok.',
      NoData: 'Liste Boş',
      NoDataError: 'Bir sorun oluştu.'
    },
    form: {
      ErrorMessages: {
        Required: 'Bu alan boş geçilemez.',
        Select:'En az bir seçenek seçilmeli.',
        Numeric: 'Bu alan yalnızca sayısal karakterler içerebilir.',
        Between: 'Bu alan {min} ile {max} arasında olmalıdır'
      },
      NoResult: 'Eşleşen veri yok.',
      Empty: 'Liste Boş',
      Loading: 'Yükleniyor...'
    },
    select: {
      NoMatching: 'Eşleşen veri bulunmamaktadır.',
      NoData: 'Liste boş.'
    },
    buttons: {
      Cancel: 'İptal',
      Approve: 'Onayla',
      Tryagain: 'Tekrar Deneyin',
      Confirm: 'Doğrula',
      Save: 'Kaydet',
      Send:'Gönder'
    },
    notifyAlert: {
      error: {
        title: 'Hata!'
      },
      success: {
        title: 'Başarılı!'
      },
      warning: {
        title: 'Uyarı!'
      }
    },
    phoneNumberInput: {
      Telephone: 'Telefon Numarası',
      TelephoneCountryCode: 'Ülke Kodu',
      TelephoneCountryCodeError: 'Bir ülke seçiniz',
      TelephoneExample: 'Örneğin :',
      errorMsj: {
        FormTelephoneEmpty: 'Telefon Numarası boş geçilemez.',
        FormTelephoneErr: 'Yanlış Telefon Numarası.',
        FormSimEmpty: 'Sim Numarası boş geçilemez.',
        FormSimErr: 'Yanlış Sim Numarası.'
      }
    },
    echarts:{
      toolbox:{
        Zoom: 'Yakınlaş',
        ZoomReset: 'Yakınlaştırmayı Sıfırlama',
        Restore:'Geri Yükle',
        SaveAsImage: 'Resim Olarak Kaydet'
      }
    }
  }
}
